const headerDataDespatch = [
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 230,
  },
  {
    prop: "VouCode",
    label: "经销商出库单号",
    columnwidth: 230,
  },
  {
    prop: "InvClassName",
    label: "产品线",
    columnwidth: 230,
  },
  {
    prop: "DPDate",
    label: "出库日期",
    columnwidth: 230,
  },
  {
    prop: "ObjName",
    label: "客户名称",
    columnwidth: 230,
  },
  {
    prop: "VoucherType",
    label: "单据类型",
    columnwidth: 230,
  },
  {
    prop: "WHName",
    label: "仓库名称",
    columnwidth: 230,
  },
  {
    prop: "Total",
    label: "出库金额",
    columnwidth: 230,
  },
  {
    prop: "Remark",
    label: "备注",
    columnwidth: 230,
  },
  {
    prop: "Creator",
    label: "创建人",
    columnwidth: 230,
  },
  {
    prop: "CreateTime",
    label: "创建时间",
    columnwidth: 230,
  },
  {
    prop: "Verifier",
    label: "审核人",
    columnwidth: 230,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 230,
  },
];

export default headerDataDespatch;
